import { MatButtonModule } from '@angular/material/button';
import { FiSnackBarService } from '@fi-shared/fi-shared-services';
import { FiSnackbarComponent } from './fi-snackbar.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatIconModule],
    declarations: [FiSnackbarComponent],
    providers: [FiSnackBarService],
})
export class FiSnackbarModule {}
